import { createApp } from 'vue'
import AssociateQR from '@/components/AssociateQR.vue'
import router from './router'
import './css/tailwind.css'
import Toaster from '@meforma/vue-toaster';


createApp(AssociateQR).use(router).use(Toaster).mount('#app')
